// extracted by mini-css-extract-plugin
module.exports = {"legalPage":"Legal_legalPage__laJTg"};